import { observer } from 'mobx-react-lite'
import type ConsultationSchedulerViewModel from '@/features/jobs/details/consultation/ConsultationSchedulerViewModel'
import { format } from 'date-fns'
import {
  AvailableTimesList,
  AvailableTime,
  type AvailableTimesListProps,
} from './'

interface AvailableTimesListContainerProps {
  vm: ConsultationSchedulerViewModel
  spacingX?: AvailableTimesListProps['spacingX']
  testId?: string
}

export const AvailableTimesListContainer = observer(
  function AvailableTimesListContainer({
    vm,
    spacingX,
    testId,
  }: AvailableTimesListContainerProps) {
    const timeSlotOptions =
      vm.selectedDay?.availableTimeSlots.map((range, index) => ({
        id: index.toString(),
        range,
      })) ?? []

    const selectedKeys = timeSlotOptions
      .filter((o) =>
        vm.selectedDay?.selectedTimeSlots.some((t) => t.isTimeEqual(o.range)),
      )
      .map((o) => o.id)

    return (
      <AvailableTimesList
        spacingX={spacingX}
        header={vm.selectedDay && format(vm.selectedDay.day, 'EEEE, d MMMM')}
        selectedKeys={new Set(selectedKeys)}
        onChange={(keys) => {
          if (keys === 'all') {
            vm.selectedDay?.selectTimeSlots(vm.selectedDay?.availableTimeSlots)
          } else {
            vm.selectedDay?.selectTimeSlots(
              timeSlotOptions.filter((o) => keys.has(o.id)).map((o) => o.range),
            )
          }
        }}
        testId={testId}
      >
        {timeSlotOptions.map((opt) => {
          const startTime = format(opt.range.startTime, 'h:mm a')
          const endTime = format(opt.range.endTime, 'h:mm a')
          return (
            <AvailableTime
              key={opt.id}
              id={opt.id}
              startTime={startTime}
              endTime={endTime}
              testId={testId ? `${testId}-time-${startTime}` : undefined}
            />
          )
        })}
      </AvailableTimesList>
    )
  },
)
